const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Visa24 = function Visa24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M26 4.2H2v15.245h24V4.2z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M25.604 16.968H2.401v2.081h23.203v-2.081z",
      fill: "#F8B600",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M25.604 4.6H2.401v2.082h23.203V4.601zM13.802 8.971l-1.227 5.717h-1.477l1.221-5.717h1.483zm6.22 3.694.782-2.149.444 2.15h-1.226zm1.651 2.024h1.372L21.847 8.97h-1.26a.676.676 0 0 0-.633.42l-2.216 5.312h1.555l.304-.845h1.898l.178.83zm-3.863-1.864c0-1.512-2.086-1.594-2.072-2.27 0-.203.198-.42.628-.483.497-.045.997.043 1.449.256l.256-1.212a3.92 3.92 0 0 0-1.381-.251c-1.449 0-2.492.772-2.502 1.888 0 .82.734 1.28 1.294 1.555.56.275.773.459.768.71 0 .386-.459.555-.883.56a3.037 3.037 0 0 1-1.522-.362l-.256 1.26c.524.203 1.08.306 1.642.304 1.555 0 2.574-.768 2.58-1.955zM11.682 8.96l-2.414 5.72h-1.54l-1.18-4.554a.633.633 0 0 0-.352-.483 6.147 6.147 0 0 0-1.448-.483l.033-.169h2.53a.695.695 0 0 1 .687.585l.623 3.308 1.535-3.893 1.526-.029z",
      fill: "#1A1F71",
    })
  );
};
Visa24.defaultProps = {
  width: "28",
  height: "24",
  viewBox: "0 0 28 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var Visa32 = function Visa32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.964 13.713c.005-1.173-.959-1.684-1.73-2.092-.516-.274-.946-.502-.94-.853.007-.266.258-.55.809-.622.273-.036 1.025-.065 1.878.332l.334-1.576a5.093 5.093 0 0 0-1.782-.328c-1.883 0-3.207 1.009-3.218 2.455-.012 1.07.946 1.666 1.667 2.023.743.364.992.597.988.923-.005.498-.593.719-1.14.727-.932.014-1.484-.247-1.92-.454l-.035-.016-.346 1.63c.446.205 1.267.384 2.117.393 2.002 0 3.31-.997 3.317-2.542zm-7.89-5.004-3.086 7.43H7.975l-1.519-5.93c-.092-.364-.172-.498-.452-.652-.458-.251-1.215-.486-1.88-.632l.046-.216h3.24c.414 0 .785.278.88.757l.802 4.3 1.981-5.057h2.001zm14.622 7.43h-1.76l-.23-1.11h-2.444l-.398 1.11h-2l2.858-6.885a.867.867 0 0 1 .812-.545h1.624l1.538 7.43zm-11.9-7.43-1.575 7.43h-1.905l1.575-7.43h1.905zm9.016 2.008-1.002 2.79h1.58l-.578-2.79z",
      fill: "#1A1F71",
    })
  );
};
Visa32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Visa24,
  32: Visa32,
};
export function Visa(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Visa' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
